import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { RouterModule } from '@angular/router'
import { CmsConfig, UrlModule, provideConfig } from '@spartacus/core'
import { MediaModule } from '@spartacus/storefront'
import { CustomAddToCartModule } from '../../cart/add-to-cart/custom-add-to-cart.module'
import { CompareProductsDirective } from '../compare-products/compare-products.directive'
import { CustomProductReplacementComponent } from './custom-product-replacement.component'

@NgModule({
  declarations: [CustomProductReplacementComponent, CompareProductsDirective],
  imports: [
    CommonModule,
    MatExpansionModule,
    RouterModule,
    MediaModule,
    UrlModule,
    CustomAddToCartModule,
    MatSlideToggleModule
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductReplacementComponent: {
          component: CustomProductReplacementComponent
        }
      }
    })
  ],
  exports: [CustomProductReplacementComponent, CompareProductsDirective]
})
export class CustomProductReplacementModule {}
